/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-video-chat': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M5 7.5h5.625v1.25H5V7.5zm0 3.125h3.125v1.25H5v-1.25zm8.125 5.625H2.5c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h10.625c.69 0 1.25.56 1.25 1.25v2.536l3.387-2.42a.625.625 0 01.988.509v8.75a.625.625 0 01-.988.509l-3.387-2.419V15c0 .69-.56 1.25-1.25 1.25zM2.5 5v10h10.625v-3.75a.625.625 0 01.988-.509L17.5 13.16V6.84l-3.387 2.419a.625.625 0 01-.988-.509V5H2.5z"/>'
  }
})
